<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="推送方式：">
            <el-select v-model="query.pushMethod" placeholder="请选择" clearable size="small">
              <el-option label="全部" :value="1"></el-option>
              <el-option label="站内推送" :value="2"></el-option>
              <el-option label="app窗口推送" :value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-date-picker v-model="query.times" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="confirmTime"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs></el-tabs>
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">新建消息</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange">
        <!-- <el-table-column type="selection" width="50" /> -->
        <el-table-column label="推送方式" prop="pushMethod" align="center" width="120">
          <template slot-scope="{row}">
            <span>{{ row.pushMethod==1?'全部':row.pushMethod==2?'站内推送':row.pushMethod==3?'App窗口推送':'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" prop="pushTitle" align="center"></el-table-column>
        <el-table-column label="推送内容" prop="pushContent" align="center" width="300"></el-table-column>
        <el-table-column label="推送用户" prop="pushUserType" align="center">
          <template slot-scope="{row}">
            <span>{{ row.pushUserType==1?'全部':row.pushUserType==2?'指定用户':row.pushUserType==3?'体验班用户':row.pushUserType==4?'研修班用户':row.pushUserType==5?'普通用户':row.pushUserType==6?'业务线人员':row.pushUserType==7?'技术线人员':row.pushUserType==8?'人事':'-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="指定用户" prop="userIdStr" align="center" width="300">
          <template slot-scope="{row}">
            <span v-if="row.pushUserType===2">{{ row.realName  }}({{ row.userPho  }})</span>
          </template>
        </el-table-column>
        <el-table-column label="推送时间" prop="createdTime" align="center" width="160"></el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <notice-add ref="noticeAdd" @created="doQueryList({})" :popType="popType"/>
  </div>
</template>

<script>
  import noticeAdd from './add'
  import sysNoticeApi from '@/api/system/sysNotice'
  import Pagination from '@/components/Pagination'
  export default {
    components: {
      Pagination,
      noticeAdd
    },
    data() {
      return {
        popType: 0, //0:新增 1:编辑
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          pushMethod:'',
          pushTimeStart:'',
          pushTimeEnd:'',
          times: null
        },
        selectItems: [],
        activeName: '1',
      }
    },
    created() {
      this.doQueryList({pageNo: 1})
    },
    methods: {
      /**
       * 选择框变化
       */
       selectionChange(val) {
        this.selectItems = val
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 重置
       */
      handleFilter() {
        this.query.pushMethod = ''
        this.query.times = null
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 获取列表数据
       */
      doQueryList({ pageNo, pageSize }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        if(this.query.times) {
          this.query.pushTimeStart = this.query.times[0]
          this.query.pushTimeEnd = this.query.times[1]
        }else {
          this.query.pushTimeStart = null
          this.query.pushTimeEnd = null
        }
        this.listLoading = true
        return sysNoticeApi.fetchList(this.query)
          .then(res => {
            this.list = res.data.list
            this.total = res.data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 删除单条记录
       */
      handleDeleteSingle(row) {
        return this.$common.confirm('是否确认删除')
          .then(() => sysNoticeApi.deleteById(row.id))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 批量删除记录
       */
      handleDeleteBatch() {
        if (this.selectItems.length <= 0) {
          this.$common.showMsg('warning', '请选择活动')
          return
        }
        return this.$common.confirm('是否确认删除')
          .then(() => sysNoticeApi.deleteBatch(this.selectItems.map(row => row.id)))
          .then(() => {
            this.$common.showMsg('success', '删除成功')
            return this.doQueryList({
              pageNo: 1
            })
          })
      },
      /**
       * 打开新建表单
       */
      handleCreate(row) {
        this.popType = 0
        this.$refs.noticeAdd.handleCreate(row)
      },
      /**
       * 打开查看表单
       */
      handleShow(row) {
        this.$emit('handleShow', row, 2)
      },
      /**
       * 打开编辑表单
       */
      handleUpdate(row, type) {
        // console.log('type: ',type);
        this.popType = type
        this.$refs.noticeAdd.handleUpdate({
          row,
          command: type
        })
      },
      handleDownload() {
        return this.$common.confirm('是否确认导出')
          .then(() => sysGoodsApi.exportExcel(this.query))
      },
    }
  }
</script>
